import React from 'react';
import { Cascader } from 'antd';

const CitySelect = props => {
  const { onChange, value, placeholder } = props;

  var cityObj = window.cityList
  if (cityObj) {
    const options = Object.keys(cityObj[1]).map(key => {
      return {
        value: cityObj[1][key],
        label: cityObj[1][key],
        children: Object.keys(cityObj[key]).map(item => {
          return {
            value: cityObj[key][item],
            label: cityObj[key][item],
          }
        })
      }
    })
    return <Cascader options={options} onChange={onChange} value={value} placeholder={placeholder} />
  }
};

export default CitySelect;
